import React from 'react';
import { FaSeedling, FaLeaf, FaPalette, FaTools } from 'react-icons/fa';
import { FaCheckCircle } from "react-icons/fa";
import ContactForm from "../components/ContactForm";
import { Helmet } from 'react-helmet';  // Importera Helmet

const Plantering = () => {
  return (
    <>
    <Helmet>
            <title>Plantering av Blommor & Buskar – Provalt Service AB</title>
            <meta name="description" content="Få hjälp med plantering för att ge din trädgård nytt liv och färg. Professionell service med fokus på hållbarhet och skönhet." />
          <link rel="canonical" href="https://provalt.se/plantering" />
          </Helmet>
      <section
        className="relative h-[50vh] bg-cover bg-center flex items-center justify-center text-white"
        style={{
          backgroundImage: "url('/images/gardening/provalt-plantering-2.webp')",
        }}
      >
        <div className="absolute inset-0 bg-black bg-opacity-50 z-0" />
        <div className="relative z-10 text-center p-6 bg-black bg-opacity-30">
          <h1 className="text-4xl md:text-5xl font-bold mb-4">Plantering</h1>
          <p className="text-xl md:text-2xl font-semibold">
            Säsongsanpassad plantering som förskönar din utemiljö
          </p>
        </div>
      </section>

      <section className="py-16 px-6 md:px-12 bg-green-50 text-gray-800">
        <div className="max-w-6xl mx-auto space-y-8">
          <h2 className="text-3xl font-bold">Trivsamma och hållbara planteringar</h2>
          <p className="text-lg">
            Rätt plantering lyfter hela fastigheten. Vi på Provalt Service AB erbjuder allt från idé och design till utförande och underhåll – för bostadsrättsföreningar, företag, fastighetsägare och offentliga miljöer. Oavsett om du vill ha blomsterprakt, grönskande entréer eller robusta buskage – vi skapar lösningar som håller.
          </p>

          <div className="flex items-start">
            <FaSeedling className="text-green-600 w-8 h-8 mr-4 mt-1" />
            <div>
              <h3 className="text-xl font-semibold">Växtval & planering</h3>
              <p>Vi hjälper dig välja växter som passar platsens ljusförhållanden, jordmån och säsong – med både estetik och skötsel i åtanke.</p>
            </div>
          </div>

          <div className="flex items-start">
            <FaPalette className="text-emerald-700 w-8 h-8 mr-4 mt-1" />
            <div>
              <h3 className="text-xl font-semibold">Design & färgkombinationer</h3>
              <p>Vi kombinerar färger, former och höjder för att skapa harmoni och variation i rabatter, krukor och offentliga planteringar.</p>
            </div>
          </div>

          <div className="flex items-start">
            <FaTools className="text-gray-600 w-8 h-8 mr-4 mt-1" />
            <div>
              <h3 className="text-xl font-semibold">Skötsel & uppföljning</h3>
              <p>Vi erbjuder löpande underhåll – som bevattning, beskärning och gödsling – så att din plantering alltid ser inbjudande ut.</p>
            </div>
          </div>

          <div className="flex items-start">
            <FaLeaf className="text-lime-700 w-8 h-8 mr-4 mt-1" />
            <div>
              <h3 className="text-xl font-semibold">Hållbar plantering</h3>
              <p>Vi arbetar med klimatvänliga växtval och jordförbättring som främjar pollinatörer och långsiktig hållbarhet.</p>
            </div>
          </div>

          <h3 className="text-2xl font-semibold pt-10">Vanliga projekt vi utför:</h3>
          <ul className="list-disc list-inside text-lg pl-4 space-y-2">
            <li>Säsongsblommor vid entréer och receptioner</li>
            <li>Rabattplantering längs gångvägar och fasader</li>
            <li>Buskage och perenner i innergårdar</li>
            <li>Krukplanteringar för kontor och butiker</li>
            <li>Plantering i nyanlagda trädgårdar och parker</li>
          </ul>

          <p className="text-lg pt-6">
            Vi tar hand om allt – från jord och dränering till plantering och städning – så att du kan luta dig tillbaka och njuta av grönskan.
          </p>

        </div>
      </section>
      <section
      className="relative py-20 px-6 md:px-12 text-gray-900">
      {/* Vit overlay med transparens */}
      <div className="absolute inset-0 bg-white/90 backdrop-blur-sm"></div>

      <div className="relative max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-16 items-start">
        {/* Textinnehåll */}
        <div className="space-y-8">
          <h2 className="text-3xl font-extrabold leading-tight">
            Professionell plantering för din trädgård
          </h2>
          <ul className="space-y-6 text-lg">
            <li className="flex items-start">
              <FaCheckCircle className="text-green-600 w-7 h-7 mr-4 mt-1" />
              <p>
                <strong>Experthjälp med växtval:</strong> Vi hjälper dig att välja rätt blommor, buskar och träd för din trädgård.
              </p>
            </li>
            <li className="flex items-start">
              <FaCheckCircle className="text-green-600 w-7 h-7 mr-4 mt-1" />
              <p>
                <strong>Skapande av vackra planteringar:</strong> Design och plantering som förhöjer din trädgårds estetik och funktion.
              </p>
            </li>
            <li className="flex items-start">
              <FaCheckCircle className="text-green-600 w-7 h-7 mr-4 mt-1" />
              <p>
                <strong>Omsorgsfull skötsel:</strong> Vi garanterar att dina planteringar får bästa möjliga start och skötsel.
              </p>
            </li>
          </ul>
        </div>

        {/* Formulär */}
        <div className="bg-white p-2 rounded-3xl shadow-xl max-w-md w-full mx-auto">
          <ContactForm service="Plantering" />
        </div>
      </div>
    </section>
    </>
  );
};

export default Plantering;
